import { createSelector } from 'reselect';

import { dashboardSelector } from 'modules/dashboard/store/selectors/dashboard';

export const countriesSelector = createSelector(dashboardSelector, (state) => state.countries);
